var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDownloadIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 60,
    viewBox: "0 0 60 60",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3104_385)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M59.043 29.8168C59.4763 34.4344 60.1951 42.3474 55.1042 49.4217C46.7834 61.0347 30.6243 59.2883 29.7873 59.1995C20.9249 58.1043 15.1939 53.0428 12.2299 50.4084C8.36983 46.9748 0.787558 40.2754 0.413369 29.8168C0.147497 21.0257 5.2286 14.7308 7.24726 12.2247C8.68494 10.4389 16.5429 0.690689 29.6888 0.493357C36.1759 0.448615 42.4867 2.60852 47.5908 6.6205C57.6546 14.4546 58.7279 26.1958 59.043 29.8168Z",
    stroke: "black",
    strokeWidth: 0.55926,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.1258 30.9207C27.5424 32.8002 28.9737 34.6807 30.556 36.3123C30.776 36.5387 31.1288 36.6478 31.3371 36.3104C33.086 33.4802 35.2319 31.0596 36.5557 27.8002C36.8952 26.9644 35.9393 26.2242 35.6005 27.058C34.3221 30.2043 32.2415 32.5383 30.5535 35.2711C30.8141 35.2705 31.074 35.2698 31.3346 35.2692C29.7522 33.6376 28.3209 31.7562 26.9044 29.8776C26.3985 29.206 25.6199 30.2501 26.1258 30.9207Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.865 36.3216C31.8854 28.9709 33.6526 21.5761 30.6871 14.2688C30.5915 14.0329 29.528 14.1364 29.6228 14.3699C32.5735 21.6416 30.7812 29.0099 30.7607 36.3243C30.7606 36.5636 31.8649 36.5607 31.865 36.3216Z",
    fill: "#030201"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17 33.9644C17.4464 37.0894 17 38.8619 17 42.0001C27.9832 41.6246 34.1412 41.7314 45.125 42.0001C45.125 38.8619 45.125 37.1025 45.125 33.9644",
    stroke: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3104_385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 59.8408,
    height: 59.8408,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownloadIcon);
export default __webpack_public_path__ + "static/media/download-icon.31b518a8d1ac9aa6307707908ff3a88a.svg";
export { ForwardRef as ReactComponent };